import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import routes from "../../react_routes_enum";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../components/Spinner/Spinner";
import DialogContent from "@mui/material/DialogContent";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { IconButton, Typography, Button } from "@mui/material";
import UserTable from "../../components/BasicTable/BasicTable";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Pagination from "../../components/Pagination/Pagination";
import SearchTextField from "../../components/SearchTextField/SearchTextField";
import { getBatches, getBatchById, updateBatchData, deleteBatchById } from "../../redux/batch/batchSlice";

const Batches = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [page, setPage] = useState(0);
    const [batchId, setBatchId] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    
    const { 
        message,
        examSearchText } = useSelector((state) => state.students)
    
    const {
        isError,
        isLoading,
        batchData,
        totalCount
    } = useSelector((state) => state.batch);
  
    const columns = [
        "SNo",
        "Created Date",
        "Batch Name",
        "For What",
        "Status",
        "Action"
    ];

    const handleClose = () => {
        setIsDialogOpen(false);
    };

    const resetStateForPaginationOfDifferentView = () => {
        setLimit(10);
        setOffset(0);
        setPage(0);
    };

    useEffect(() => {
        const res = dispatch(getBatches({limit, offset}));
        res?.then((r) => {
            if(r.payload.message === "unauthorized" || 
                r.payload.message === "Unauthorized" ||
                r.payload.message === "Session Expired"){
                toast.error("Session expired, please login again");
                localStorage.removeItem("hp_token");
                localStorage.removeItem("hp_user");
                navigate(routes.LOGIN);
            }
        })
    }, [limit, offset]);

    const handleSearchText = (e) => {
        resetStateForPaginationOfDifferentView();
        if (limit === 10 && offset === 0) {
          const res = dispatch(getBatches({ limit, offset, searchText: examSearchText}));
          res?.then((r) => {
            if(r?.payload?.message.toLowerCase() === "unauthorized" || 
              r?.payload?.message === "Session Expired"){
              toast.error("Session expired, please login again");
              localStorage.removeItem("hp_token");
              localStorage.removeItem("hp_user");
              navigate(routes.LOGIN);
            }
          })
        }
    };

    const batchDetail = (id) => {
        const res = dispatch(getBatchById({id}));
        res?.then((r) => {
            if(r?.payload?.statusCode === 200){
                navigate(routes.EDIT_BATCH);
                return;
            }
            if(r?.payload?.message.toLowerCase() === "unauthorized" || 
                r?.payload?.message === "Session Expired"){
                toast.error("Session expired, please login again");
                localStorage.removeItem("hp_token");
                localStorage.removeItem("hp_user");
                navigate(routes.LOGIN);
                return;
            }
            toast.error(r?.payload?.message);
        })
    }

    const deleteBatch = () => {
        const res = dispatch(deleteBatchById(batchId));
        res?.then((r) => {
            if(r?.payload?.statusCode === 200){
                setIsDialogOpen(false);
                toast.success("Batch Deleted Successfully");
                dispatch(getBatches({ limit, offset, searchText: "" }));
            }else{
                if(r?.payload?.message.toLowerCase() === "unauthorized" || 
                    r?.payload?.message === "Session Expired"){
                    toast.error("Session expired, please login again");
                    localStorage.removeItem("hp_token");
                    localStorage.removeItem("hp_user");
                    navigate(routes.LOGIN);
                    return;
                }
                toast.error(r?.payload?.message);
            }
        })
    }

    const updateStatus = (id, status) => {
        const body = status === "Active" ? {status: "Inactive"} : {status: "Active"};
        const res = dispatch(updateBatchData({id, body }));
        res?.then((r) => {
            if(r?.payload?.statusCode === 200){
                setIsDialogOpen(false);
                toast.success("Status Updated Successfully");
                dispatch(getBatches({ limit, offset, searchText: "" }));
            }else{
                if(r?.payload?.message.toLowerCase() === "unauthorized" || 
                    r?.payload?.message === "Session Expired"){
                    toast.error("Session expired, please login again");
                    localStorage.removeItem("hp_token");
                    localStorage.removeItem("hp_user");
                    navigate(routes.LOGIN);
                    return;
                }
                toast.error(r?.payload?.message);
            }
        })
    }

    if (isLoading) return <Spinner />;

    if (isError) return <h1 style={{ color: "red" }}>{message}</h1>;
  
    return (
        <div style={{ marginTop: '5%' }}>
            <Dialog maxWidth="sm" open={isDialogOpen} onClose={handleClose} fullWidth>
                <DialogContent>
                    <Typography
                        variant="p"
                        component="p"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            margin: '28px 0 48px'
                        }}
                    >
                        Are you sure you want to<br/> delete the batch ?
                    </Typography>
                    <div 
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'row-reverse',
                            padding: '0px 16px 28px 16px'
                        }}
                    >
                        <Button
                            variant="outlined"
                            sx={{ textTransform: 'capitalize' }}
                            onClick={() => {setIsDialogOpen(false)}}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={deleteBatch} 
                            sx={{
                                width: '84px',
                                marginRight: '12px',
                                textTransform: 'capitalize',
                                backgroundColor: 'var(--primary-color)',
                            }}
                        >
                            Yes
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
            <SearchTextField
                fromWhere="availableExams"
                searchText={examSearchText}
                handleSearchText={handleSearchText}
            />
            <div style={{textAlign: 'right'}}>
                <Button
                    variant="contained"
                    onClick={() => {navigate(routes.ADD_BATCH)}}
                    sx={{
                        borderRadius: '8px',
                        backgroundColor: '#F69220',
                        textTransform: 'capitalize'
                    }}
                >
                    <ControlPointIcon sx={{marginRight: '4px'}} />
                    Add New Batch
                </Button>
            </div>
            <Pagination
                totalCount={totalCount}
                limit={limit}
                page={page}
                changeLimit={setLimit}
                changeOffset={setOffset}
                changePage={setPage}
            />
            <UserTable
                columns={columns}
                rows={
                    batchData &&
                    batchData?.map((item) => {
                    const res = {
                        ...item,
                        Status: (
                            <div>
                                {item?.status === "Active" ?
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                        onClick={() => updateStatus(item._id, item.status)}
                                    >
                                        <Typography
                                            variant="p"
                                            component="p"
                                            sx={{
                                                color: '#07AB35',
                                                fontSize: '18px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {item?.status}
                                        </Typography>
                                    </IconButton> 
                                :
                                    <IconButton
                                        color="inherit"
                                        edge="start"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                        onClick={() => updateStatus(item._id, item.status)}
                                    >
                                        <Typography
                                            component="p"
                                            variant="p"
                                            sx={{
                                                color: '#EF0000',
                                                fontSize: '18px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {item?.status}
                                        </Typography>
                                    </IconButton>
                                }
                            </div>
                        ),
                        Action: (
                            <div 
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start"
                                }}
                            >
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                    onClick={() => batchDetail(item._id)}
                                >
                                    <BorderColorIcon sx={{color: '#ECAB2D'}} />
                                    <Typography
                                        variant="p"
                                        component="p"
                                        sx={{
                                        color: '#ECAB2D',
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        marginTop: '6px'
                                        }}
                                    >
                                        Edit
                                    </Typography>
                                </IconButton>
                                <IconButton
                                    color="inherit"
                                    edge="start"
                                    sx={{
                                        display: 'flex',
                                        marginLeft: '4px',
                                        flexDirection: 'column',
                                    }}
                                    onClick={() => {
                                        setIsDialogOpen(true)
                                        setBatchId(item._id)
                                    }}
                                >
                                    <DeleteIcon sx={{color: '#EF0000'}} />
                                    <Typography
                                        component="p"
                                        variant="p"
                                        sx={{
                                            color: '#EF0000',
                                            fontSize: '18px',
                                            fontWeight: 'bold',
                                            marginTop: '6px'
                                        }}
                                    >
                                        Delete
                                    </Typography>
                                </IconButton>
                            </div>
                        )
                    };
                    return res;
                })
                }
            />
        </div>
    );
};

export default Batches;